export const JOB_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  TIMED_OUT: "TIMED_OUT",
  STOPPED: "STOPPED",
};

// Status reads: every 5 s while the socket is down, every 15 s as a safety net while it is up.
export const JOB_STATUS_POLL_MS = 5000;
export const JOB_STATUS_SAFETY_MS = 15000;
// Tracking stops only after this long with no progress change (a slow job that keeps progressing is never cut off).
export const JOB_TRACK_IDLE_MS = 15 * 60 * 1000;
export const JOB_TIMED_OUT_MESSAGE = "Still processing — refresh later to see the result.";

export const JOB_CARD_REMOVE_DELAY_MS = 1000;
export const JOB_CARD_FAILED_REMOVE_DELAY_MS = 3000;

export const COA_JOB_STATUS_URL = (jobId) => `chart-of-accounts/async-job-status/${jobId}`;

// TPX-2745: HMG reprocess progress + "already running" reporting from Sync / Save with "Update existing plans"
export const HMG_REPROCESS_PROGRESS_URL = (hmgId) => `/re-process/get-reprocessed-progress-detail/${hmgId}`;
export const REPROCESS_IN_PROGRESS = "REPROCESS_IN_PROGRESS";
export const REPROCESS_STATUS = {
  QUEUED: "QUEUED",
  NOTHING_TO_REPROCESS: "NOTHING_TO_REPROCESS",
  ALREADY_RUNNING: "ALREADY_RUNNING",
};
export const REPROCESS_ALREADY_RUNNING_SAVE_MESSAGE =
  "Mappings saved. Plans weren't updated because a reprocess is already running for this HMG — use Sync mapping changes when it finishes.";
